import axios from 'axios';

export const getAllPartnersService = async () => {
    return axios.get(`/partners`);
};
